import type { StatusSegment } from './DeliveryStatusBar';
import { VisitStatus } from '../enums';

interface StatusLegendProps {
  segments: StatusSegment[];
  selectedStatus?: VisitStatus | null;
  onToggle: (status: VisitStatus) => void;
}

const StatusLegend = ({ segments, selectedStatus, onToggle }: StatusLegendProps) => (
  <div className='flex flex-wrap gap-x-5 gap-y-2'>
    {segments.map((segment) => {
      const isSelected = selectedStatus === segment.status;
      const isDimmed = Boolean(selectedStatus) && !isSelected;
      const label = segment.value === 1 ? 'visita' : 'visitas';

      return (
        <button
          key={segment.status}
          type='button'
          onClick={() => onToggle(segment.status)}
          className={`flex items-center gap-2 rounded-full px-1 py-0.5 text-sm transition-opacity cursor-pointer ${
            isSelected ? 'font-bold text-gray-900' : 'text-gray-700'
          } ${isDimmed ? 'opacity-40' : ''}`}
        >
          <span
            className='h-2.5 w-2.5 shrink-0 rounded-full'
            style={{ backgroundColor: segment.color }}
          />
          {segment.name}: {segment.value} {label}
        </button>
      );
    })}
  </div>
);

export default StatusLegend;
